import React from 'react'
import PropTypes from "prop-types";
import {setupOnExtractData} from "../../../util/FormUtil";
import {PROP_NAME_JOB_ROLE} from "./AboutYouInputComponent";


export const PROP_NAME_TRADES_FUTURES = "tradesFutures";
export const PROP_NAME_TRADES_OPTIONS_ON_FUTURES = "tradesOptionsOnFutures";
export const PROP_NAME_TRADES_OTC_CLEARED_SWAPS = "tradesOTCClearedSwaps";
export const PROP_NAME_TRADES_CASH_TREASURIES_AND_REPO = "tradesCashTreasuriesAndRepo"
export const PROP_NAME_TRADES_FX_SPOT_AND_FORWARDS = "tradesFXSpotAndForwards";
export const PROP_NAME_TRADES_DOES_NOT_TRADE = "tradesDoesNotTrade";
const checkboxMetadata = {dirty: true, valid: true};
const KEYS = [PROP_NAME_TRADES_FUTURES, PROP_NAME_TRADES_OPTIONS_ON_FUTURES, PROP_NAME_TRADES_OTC_CLEARED_SWAPS,
    PROP_NAME_TRADES_CASH_TREASURIES_AND_REPO, PROP_NAME_TRADES_FX_SPOT_AND_FORWARDS, PROP_NAME_TRADES_DOES_NOT_TRADE];

class TradeClearInputComponent extends React.Component {
    constructor(props) {
        super(props);
        this.checkBoxChange = this.checkBoxChange.bind(this);
        this.extractData = this.extractData.bind(this);
    }

    componentDidMount() {
        const {setFormState, metadata, data} = this.props;

        //Init to yes
        for (let i = 0; i < KEYS.length; i++){
            const key = KEYS[i];
            if (! metadata[key]){
                setFormState({property: key, data: data[key] ? data[key] : false , metadata: checkboxMetadata});
            }
        }
        setupOnExtractData(this);
    }

    checkBoxChange(e){
        const {setFormState} = this.props;
        setFormState(
            {property: e.target.id, data: e.target.checked, metadata: checkboxMetadata}
        );
    }

    extractData(){
        const {data} = this.props;
        const result = {};
        for (let i = 0; i < KEYS.length; i++){
            const key = KEYS[i];
            result[key] = data[key];
        }
        return result;
    }

    render() {
        const {data} = this.props;
        let showExtraProducts = data[PROP_NAME_JOB_ROLE] !== 'Independent Trader/Investor';

        return (
            <div className={"grid"}>
                <div className="grid__col-sm-4 padding-bottom-ctrl">
                    <ul className={"form-fields check-list--medium"}>
                        <li>
                            <input type={"checkbox"}
                                   id={PROP_NAME_TRADES_FUTURES}
                                   checked={data[PROP_NAME_TRADES_FUTURES]}
                                   onChange={this.checkBoxChange}
                            />
                            <label htmlFor={PROP_NAME_TRADES_FUTURES}>Futures</label>
                        </li>
                        <li>
                            <input type={"checkbox"}
                                   id={PROP_NAME_TRADES_OPTIONS_ON_FUTURES}
                                   checked={data[PROP_NAME_TRADES_OPTIONS_ON_FUTURES]}
                                   onChange={this.checkBoxChange}
                            />
                            <label htmlFor={PROP_NAME_TRADES_OPTIONS_ON_FUTURES}>Options on Futures</label>
                        </li>
                        {
                            showExtraProducts &&
                            <li>
                                <input type={"checkbox"}
                                       id={PROP_NAME_TRADES_OTC_CLEARED_SWAPS}
                                       checked={data[PROP_NAME_TRADES_OTC_CLEARED_SWAPS]}
                                       onChange={this.checkBoxChange}
                                />
                                <label htmlFor={PROP_NAME_TRADES_OTC_CLEARED_SWAPS}>OTC Cleared Swaps</label>
                            </li>
                        }
                    </ul>
                </div>
                <div className="grid__col-sm-6">
                    {
                        showExtraProducts &&
                        <ul className={"form-fields check-list--medium"}>
                            <li>
                                <input type={"checkbox"}
                                       id={PROP_NAME_TRADES_CASH_TREASURIES_AND_REPO}
                                       checked={data[PROP_NAME_TRADES_CASH_TREASURIES_AND_REPO]}
                                       onChange={this.checkBoxChange}
                                />
                                <label htmlFor={PROP_NAME_TRADES_CASH_TREASURIES_AND_REPO}>Cash Treasuries/EU
                                    Bonds/Repo</label>
                            </li>
                            <li>
                                <input type={"checkbox"}
                                       id={PROP_NAME_TRADES_FX_SPOT_AND_FORWARDS}
                                       checked={data[PROP_NAME_TRADES_FX_SPOT_AND_FORWARDS]}
                                       onChange={this.checkBoxChange}
                                />
                                <label htmlFor={PROP_NAME_TRADES_FX_SPOT_AND_FORWARDS}>FX Spots/Forwards/Non-Deliverable
                                    Forwards</label>
                            </li>
                            <li>
                                <input type={"checkbox"}
                                       id={PROP_NAME_TRADES_DOES_NOT_TRADE}
                                       checked={data[PROP_NAME_TRADES_DOES_NOT_TRADE]}
                                       onChange={this.checkBoxChange}
                                />
                                <label htmlFor={PROP_NAME_TRADES_DOES_NOT_TRADE}>Do not currently trade</label>
                            </li>
                        </ul>
                    }
                </div>
                <div className="grid__col-sm-2 no-padding-bottom">
                </div>
            </div>
        );
    }
}

TradeClearInputComponent.propTypes = {
    // This is the object that contains properties like country, address, etc
    data: PropTypes.object.isRequired,
    metadata: PropTypes.object.isRequired,

    // This is the function to set properties of the "data" object. The function should take property name as first parameter and the value as the second parameter.
    setFormState: PropTypes.func.isRequired,
    onExtractData: PropTypes.func
};

export default TradeClearInputComponent;

